<template>
  <div>
    <list-loader v-if="showSkeletonLoader" />
    <div v-else-if="showList">
      <slot name="items"></slot>
    </div>
    <div v-else-if="showNofFound" class="not-found-container">
      <slot name="not-found"></slot>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import ListLoader from '@/loaders/ListLoader'

export default {
  mixins: [navigationMixin],
  components: {
    ListLoader
  },
  props: {
    list: {
      required: true
    }
  },
  data () {
    return {
      listConfig: null
    }
  },
  computed: {
    ...mapState('shared', ['loading']),
    showSkeletonLoader () {
      return this.loading && !this.list
    },
    showList () {
      return !!this.list
    },
    showNofFound () {
      return !this.list
    }
  }
}
</script>
<style scoped>
.not-found-container {
  display: flex;
  justify-content: center;
}
</style>
